import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssetVehicleDetailsComponent } from './asset-vehicle-details/asset-vehicle-details.component';
import { AssetVehicleLinkComponent } from './asset-vehicle-link/asset-vehicle-link.component';
import { AssetVehicleLandingComponent } from './asset-vehicle-landing/asset-vehicle-landing.component';

const routes: Routes = [
  {
    path: '', component: AssetVehicleLinkComponent,
    children: [
      { path: 'vehicleQREntry', component: AssetVehicleLandingComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssetvehicleRoutingModule { }
